import { LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

const schema: LandingScreenSchema = {
	config: { background: 'transparent' },
	order: ['LandingGlp1'],
	components: {},
}

export default schema
